import React from 'react'
import {
  AutoCompleterV3,
  AutoCompleterConfig
} from '../../../components/_WMS/AutoCompleterV3'
import { ComponentProps } from '../../../components/_WMS/FilterComponent/types'
import { createFilterValueWithDisplay } from '../../../types/filters'
import { ApiConfig } from '../../../config/api'
import { Warehouse } from '../../../interfaces/Warehouse/Warehouse'

const warehouseConfig: AutoCompleterConfig<Warehouse> = {
  searchEndpoint: `${ApiConfig.WareHouseApi}/searchByName`,
  searchParam: 'searchText',
  keyField: 'id',
  displayField: 'warehouseName',
  minSearchLength: 3,
  debounceMs: 300,
  pageSize: 10
}

export const WarehouseAutoCompleter: React.FC<ComponentProps> = ({
  value,
  onChange,
  fullWidth = true,
  transformForBackend,
  transformForDisplay
}) => {
  const [selectedWarehouse, setSelectedWarehouse] = React.useState<Warehouse | null>(
    null
  )

  // Sincronizar con el valor externo cuando cambie
  React.useEffect(() => {
    if (value && value !== selectedWarehouse?.id.toString()) {
      // Si hay un valor pero no coincide con el seleccionado, limpiar
      setSelectedWarehouse(null)
    }
  }, [value, selectedWarehouse])

  const handleWarehouseChange = (warehouse: Warehouse | null) => {
    setSelectedWarehouse(warehouse)

    // Si hay transformadores disponibles, usar el enfoque JSON para compatibilidad con FilterComponent
    // Si no, usar el valor simple (para casos donde se use fuera de FilterComponent)
    let eventValue = ''
    if (warehouse) {
      if (transformForBackend && transformForDisplay) {
        // Usar función tipada para FilterComponent
        eventValue = createFilterValueWithDisplay(
          warehouse.id,
          `${warehouse.warehouseName} (${warehouse.warehouseCode})`
        )
      } else {
        // Usar valor simple para otros casos
        eventValue = warehouse.id.toString()
      }
    }

    const syntheticEvent = {
      target: {
        value: eventValue,
        name: 'warehouseId'
      }
    } as React.ChangeEvent<HTMLInputElement>

    onChange(syntheticEvent)
  }

  const renderOption = (warehouse: Warehouse) => (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start'
      }}
    >
      <div style={{ fontWeight: 'bold' }}>{warehouse.warehouseName}</div>
      <div style={{ fontSize: '0.875rem', color: '#666' }}>
        Código: {warehouse.warehouseCode}
      </div>
    </div>
  )

  const renderValue = (warehouse: Warehouse) =>
    `${warehouse.warehouseName} (${warehouse.warehouseCode})`

  return (
    <AutoCompleterV3<Warehouse>
      config={warehouseConfig}
      value={selectedWarehouse}
      onChange={handleWarehouseChange}
      placeholder='Buscar Almacén ...'
      renderOption={renderOption}
      renderValue={renderValue}
      width={fullWidth ? '100%' : 300}
    />
  )
}
